import axios from 'axios';
import c from '../helpers/constants';
import { EmailForgotPassword, EmailMessage, EmailNotifyStock } from '../types/Email';

export function submitMessage(data: EmailMessage) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.EMAIL_SUBMIT_MESSAGE}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function forgotPassword(data: EmailForgotPassword) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.EMAIL_FORGOT_PASSWORD}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function notifyStock(data: EmailNotifyStock) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.EMAIL_NOTIFY_STOCK}`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}
